
export default function About() {
  const stats = [
    { number: '25+', label: 'Years Practice' },
    { number: '10,000+', label: 'Patients Served' },
    { number: '50+', label: 'Insurance Partners' },
    { number: '24/7', label: 'Emergency Support' }
  ];

  return (
    <section className="py-20 bg-white/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in-left opacity-0">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Meet Dr. John Peterson
            </h2>
            <div className="text-lg text-blue-600 font-semibold mb-4">
              Farmers Insurance Agent | Founder of The Insurance Doctors
            </div>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              John Peterson is a trusted Farmers Insurance agent and the founder of The Insurance Doctors, where he blends deep expertise in insurance and financial services to help individuals, families, and business owners protect what matters most.
            </p>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  icon: "ri-stethoscope-line",
                  title: "Expert Diagnosis",
                  description: "With years of experience, John diagnoses coverage gaps like a doctor and prescribes tailored solutions for each client's needs.",
                  delay: "200ms"
                },
                {
                  icon: "ri-medicine-bottle-line",
                  title: "Financial Services Background",
                  description: "John understands how insurance fits into the bigger picture - from protecting assets to supporting long-term financial goals.",
                  delay: "400ms"
                },
                {
                  icon: "ri-hospital-line",
                  title: "Comprehensive Care",
                  description: "Through Farmers Insurance and The Insurance Doctors, John provides full-range coverage backed by one of the nation's most respected carriers.",
                  delay: "600ms"
                }
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-start animate-fade-in-up opacity-0 hover:transform hover:translate-x-2 transition-all duration-300"
                  style={{ animationDelay: item.delay }}
                >
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4 mt-1 hover:bg-blue-600 hover:scale-110 transition-all duration-300 group">
                    <i className={`${item.icon} text-blue-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gray-50/90 backdrop-blur-sm rounded-xl p-6 mb-8 border border-gray-200/50">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">What Sets John Apart:</h3>
              <p className="text-gray-600 leading-relaxed">
                "I listen first, diagnose coverage gaps like a doctor would, and then prescribe solutions that make sense for both protection and budget. My straightforward, no-nonsense approach helps clients get the peace of mind and financial freedom they deserve."
              </p>
            </div>

            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer animate-fade-in-up opacity-0" style={{ animationDelay: '800ms' }}>
              Schedule Your Consultation with John
            </button>
          </div>

          <div className="relative animate-fade-in-right opacity-0">
            <img 
              src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/db1af4aa0868dd8f7865b0f8b762d1f3.jfif"
              alt="John Peterson - Farmers Insurance Agent and Founder of The Insurance Doctors"
              className="rounded-2xl shadow-2xl object-cover w-full h-96 lg:h-[500px] hover:scale-105 transition-transform duration-500"
            />
            
            <div className="absolute -bottom-8 -left-8 bg-white/95 backdrop-blur-sm rounded-xl shadow-xl p-6 animate-fade-in-up opacity-0 hover:shadow-2xl transition-shadow duration-300 border border-white/20" style={{ animationDelay: '600ms' }}>
              <div className="grid grid-cols-2 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center hover:scale-110 transition-transform duration-300">
                    <div className="text-2xl font-bold text-blue-600">{stat.number}</div>
                    <div className="text-sm text-gray-600 whitespace-nowrap">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Professional credentials badge */}
            <div className="absolute -top-4 -right-4 bg-blue-600 text-white rounded-full px-4 py-2 shadow-lg animate-fade-in-up opacity-0" style={{ animationDelay: '400ms' }}>
              <div className="text-xs font-semibold">Farmers Insurance</div>
              <div className="text-xs">Licensed Agent</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
